export default __webpack_public_path__ + "static/media/ref.6e2458c7.jpg";